// extracted by mini-css-extract-plugin
export var layoutContainer = "_dm-0";
export var layoutContainerNoRounding = "_dm-6";
export var layoutContainerOpen = "_dm-5";
export var layoutContainerResizing = "_dm-1";
export var mainContent = "_dm-2";
export var resizeDivider = "_dm-3";
export var slidePanel = "_dm-4";